import styles from "./Spinner.module.scss";

import { cn } from "@/utils/cn";

enum SpinnerVariant {
  Primary = "primary",
  Secondary = "secondary",
}

enum SpinnerSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

enum SpinnerAppearance {
  Default = "default",
  Solid = "solid",
}

type Props = {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  appearance?: SpinnerAppearance;
  className?: string;
};

const Spinner: React.FC<Props> = ({
  size = SpinnerSize.Medium,
  variant = SpinnerVariant.Secondary,
  appearance = SpinnerAppearance.Default,
  className,
}) => (
  <div
    className={cn(
      styles.spinner,
      styles[size],
      styles[appearance],
      styles[variant],
      className
    )}
  >
    <div className={styles.dot} />
    <div className={styles.dot} />
    <div className={styles.dot} />
  </div>
);

export { Spinner, SpinnerSize, SpinnerAppearance, SpinnerVariant };
